/**
 * Shared PostHog configuration for AgencyOS
 * Used by both frontend (React) and backend (Lambda functions)
 */

export const POSTHOG_TOKEN = 'phc_ufZLXUL4Ky3j7ngZfU47rsWnvUg6CfhCDRJWJaq9Nx2D';
export const POSTHOG_HOST = 'https://us.i.posthog.com';
